import React from 'react';
import Breadcrump from '../../components/Breadcrump';

const Expansion = () => {
  return (
    <>
      <Breadcrump title='Expansion Zones'/>
      <section className="ith-availability-section py-5">
        <div className="container-fluid">
          
          {/* Table 1: Sonipat */}
          <div className="ith-table-wrapper">
            <h2 className="ith-section-title-table">Availability</h2>
            <table className="ith-essentials-table">
              <tbody>
                <tr><th>IMT Kundli</th><td>HSIIDC-managed clusters—Apparel, Food, EPIP</td></tr>
                <tr><th>Rai Industrial Estate</th><td>DMIC-linked, Food Park, Logistics hub</td></tr>
                <tr><th>IMT Kharkhoda</th><td>KMP connectivity, Maruti plant</td></tr>
                <tr><th>Ratangarh Free Zone</th><td>Large private plots, near expressway</td></tr>
                <tr><th>Barhi Food Park</th><td>Agro-processing hub</td></tr>
                <tr><th>Industrial Estate Sonipat</th><td>Traditional mixed industries</td></tr>
                <tr><th>Murthal Industrial Area</th><td>Light goods, logistics, roadside services</td></tr>
                <tr><th>Dhaturi Industrial Area</th><td>SME zone emerging</td></tr>
                <tr><th>Hassanpur Industrial Zone</th><td>Smaller feeder cluster</td></tr>
                <tr><th>Gohana Industrial Area</th><td>Agro-based manufacturing</td></tr>
                <tr><th>Rajiv Gandhi Education City</th><td>Ed-tech hub with some industrial R&D</td></tr>
                <tr><th>Model Township Bahalgarh</th><td>SME auto/engineering units</td></tr>
              </tbody>
            </table>
          </div>

          {/* Table 2: Panipat */}
          <div className="ith-table-wrapper">
            <h2 className="ith-section-title-table">Key Industrial Areas & Highlights (Panipat)</h2>
            <table className="ith-essentials-table">
              <tbody>
                <tr>
                  <th>Panipat Refinery Industrial Area</th>
                  <td>- Home to IOCL Panipat Refinery (India's second largest)<br/>- Surrounding petrochemical units and chemical industries</td>
                </tr>
                <tr>
                  <th>Sector 29 Part I & II Industrial Area</th>
                  <td>- Well-developed by HSIIDC<br/>- Houses textile, garment, and packaging units</td>
                </tr>
                <tr>
                  <th>Samalkha Industrial Area</th>
                  <td>- Located in southern Panipat<br/>- Known for agricultural implements, hardware, and engineering goods</td>
                </tr>
                <tr>
                  <th>Panipat Textile Cluster</th>
                  <td>- One of Asia's largest handloom and textile manufacturing zones</td>
                </tr>
                <tr>
                  <th>Industrial Area – Sewah</th>
                  <td>- Near the NH-44 bypass<br/>- Houses oil mills, plastic units, small-scale manufacturers</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Table 3: NH-44 Belt */}
          <div className="ith-table-wrapper">
            <h2 className="ith-section-title-table">Major Industrial Areas from Kundli to Ambala (NH-44 / GT Road Belt)</h2>
            <table className="ith-essentials-table ith-kundli-ambala-table">
              <tbody>
                <tr>
                  <th>Kundli & Sonipat</th>
                  <td>
                    <ul className="ith-table-list">
                      <li>IMT Kundli (Apparel, Food, EPIP)</li>
                      <li>Murthal Industrial Area & Barhi Food Park</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <th>Panipat & Karnal</th>
                  <td>
                    <ul className="ith-table-list">
                      <li>Panipat Refinery & Textile Cluster</li>
                      <li>Namaste Chowk Zone (Karnal)</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <th>Kurukshetra & Ambala</th>
                  <td>
                    <ul className="ith-table-list">
                      <li>Sector 3/4/13 Light engineering (Kurukshetra)</li>
                      <li>Scientific Instruments Cluster (Ambala)</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Table 4: Himachal Pradesh (Header on top logic) */}
          <div className="ith-table-wrapper" style={{maxWidth: '90%'}}>
            <h2 className="ith-section-title-table">Major Industrial Areas in Himachal Pradesh</h2>
            <table className="ith-essentials-table ith-hp-industrial-table">
              <thead>
                <tr>
                  <th>Region / Town</th>
                  <th>Key Industrial Areas</th>
                  <th>Primary Industries</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Baddi</td>
                  <td>Baddi Industrial Area, EPIP Jharmajri</td>
                  <td>Pharmaceuticals, FMCG, Cosmetics</td>
                </tr>
                <tr>
                  <td>Nalagarh</td>
                  <td>Nalagarh Industrial Area, Majra Cluster</td>
                  <td>Food processing, Chemicals, Paints</td>
                </tr>
                <tr>
                  <td>Paonta Sahib</td>
                  <td>Paonta Sahib Industrial Area, Gondpur</td>
                  <td>Pharma, Paper, Cement</td>
                </tr>
                <tr>
                  <td>Parwanoo</td>
                  <td>Parwanoo Industrial Estate (Sec 1-4)</td>
                  <td>Electronics, Food processing, Plastics</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </section>
    </>
  );
};

export default Expansion;